"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
exports.default = {
    root: {
        fontSize: constants_1.PROSE_FONT_SIZE,
        fontWeight: constants_1.PROSE_FONT_WEIGHT,
        lineHeight: constants_1.PROSE_LINE_HEIGHT,
        color: constants_1.PROSE_COLOR,
        '&[data-is-small=true]': {
            fontSize: constants_1.PROSE_FONT_SIZE_SMALL,
            lineHeight: constants_1.PROSE_LINE_HEIGHT_SMALL
        },
        '&[data-is-light=true]': {
            color: constants_1.PROSE_COLOR_LIGHT
        },
        '&[data-break-after=true]::after': {
            content: '" "',
            whiteSpace: 'pre',
            display: 'block'
        },
        '& strong': {
            fontWeight: constants_1.PROSE_FONT_WEIGHT_BOLD
        }
    }
};
//# sourceMappingURL=prose.style.js.map